import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    legenda: {
        padding: "16px",
        maxWidth: "400px",
        "& ul": {
            paddingInlineStart: "16px",
        },
    },
}));

const PopUpLegenda = ({ 
    texto, 
    title = "Informações",
    anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
    transformOrigin = { vertical: 'top', horizontal: 'right' }
}) => {
    const classes = useStyles();
    const [ancora, setAncora] = useState(null);

    const handleOpen = (event) => {
        setAncora(event.currentTarget);
    };

    const handleClose = () => {
        setAncora(null);
    };

    const open = Boolean(ancora);

    return (
        <>
            <Tooltip title={title} TransitionComponent={Zoom}>
                <IconButton
                    size="small"
                    color="default"
                    aria-label={title}
                    onClick={handleOpen}
                >
                    <InfoOutlinedIcon />
                </IconButton>
            </Tooltip>
            <Popover
                open={open}
                anchorEl={ancora}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                <Typography className={classes.legenda} variant="body2" dangerouslySetInnerHTML={{ __html: texto }}></Typography>
            </Popover>
        </>
    );
};

export default PopUpLegenda;
